import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/_coach/orgs/$slug/workouts")({
  component: RouteComponent,
  ssr: true,
  staticData: {
    getBreadcrumb({ params }) {
      return {
        href: `/orgs/${params.slug}/workouts`,
        labelTranslationKey: "workoutsPage.breadcrumb",
      };
    },
  },
});

function RouteComponent() {
  return <Outlet />;
}
